module.exports = __webpack_public_path__ + "img/book20.fc9796b1.jpg";